/* eslint-disable import/prefer-default-export */
export enum NotificationType {
    Invoice = 'INVOICE',
    InvoiceExpiration = 'INVOICE_EXPIRATION',
    Budget = 'BUDGET',
    BudgetExpiration = 'BUDGET_EXPIRATION',
    SellerRegister = 'SELLER_REGISTER',
}
